// component
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import HandshakeIcon from '@mui/icons-material/Handshake';
import RateReviewIcon from '@mui/icons-material/RateReview';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import SvgColor from '../../../components/svg-color';



// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const Master = [
  {
    title: 'Blogs',
    path: '/dashboard/ask/blogs',
    icon: icon('state'),
  },
  {
    title: 'Case Study',
    path: '/dashboard/ask/case_study',
    icon: <LibraryBooksIcon />,
  },
  {
    title: 'Reviews',
    path: '/dashboard/ask/client_reviews',
    icon: icon('terms'),
  },
  {
    title: 'Product Master',
    path: '/dashboard/ask/product_master',
    icon: <LibraryBooksIcon />,
  },
  {
    title: 'FAQ Master',
    path: '/dashboard/ask/faq_master',
    icon: <RateReviewIcon />,
  },
  {
    title: 'SMTP Profile Master',
    path: '/dashboard/ask/smtp_profile_master',
    icon: <SettingsEthernetIcon />,
  },
  {
    title: 'Enquiries',
    path: '/dashboard/ask/web_enquires',
    icon: <RateReviewIcon />,
  },
  {
    title: 'Users',
    path: '/dashboard/users_access_control',
    icon: icon('admin'),
  },
  {
    title: 'Our Partners',
    path: '/dashboard/our_partners',
    icon: <HandshakeIcon />,
  },
  
];

export default Master;
